// console.log("READ - dl-index_test.js")
class DL_Test extends HTMLElement {
  constructor() {
    super();
    DL_addClass(this, 'is-xxxxxxx');
    this.init();
    window.addEventListener('resize', this.onResize.bind(this));
  }
  init() {
    // console.log(this + " - init")
    this.text = Math.random() * 1;
    this.textContent = this.text;
  }
  onResize() {
    //reisize
    this.init();
  }
  connectedCallback() {} //add
  disconnectedCallback() {} //remove
  attributeChangedCallback() {} //属性変更
}
customElements.define('dl-js-test', DL_Test);
////////////////////////////////////////////////Personalize
class DL_Personalize extends HTMLElement {
  constructor() {
    super();
    const modal = this;
    this._WLClickEvt();
    modal.openFlg = false;
    ////////////////////////CLOSEボタン
    modal.closeButton = document.querySelectorAll('.dl-personalize__close');
    for (var i = 0; i < modal.closeButton.length; i++) {
      modal.closeButton[i].addEventListener(
        'click',
        function () {
          if (modal.classList.contains('is-open') == true) {
            modal.openFlg = true;
          }
          modal.close();
        },
        false,
      );
    }
    ////////////////////////確認ボタン

    modal.confirmButton = document.querySelectorAll(
      '.dl-personalize__confirm__button',
    );
    for (var i = 0; i < modal.confirmButton.length; i++) {
      modal.confirmButton[i].addEventListener(
        'click',
        function (event) {
          
          modal.checkError();
          this.customIconElm = document.querySelector(
            '[name="custom-icon"]:checked',
          );
          this.cost = JSON.parse(
            this.customIconElm.dataset.wlEngravingPriceProduct,
          );
          document.querySelector(
            '.dl-personalize__confirm__price__total .total',
          ).innerHTML = `
            ${
              document.querySelector('[name="quantity"]').value == 1
                ? ''
                : document.querySelector('[name="quantity"]').value +
                  '点分合計 '
            }¥${(
            (parseInt(this.customIconElm.dataset.productPrice) +
              this.cost?.price / 100) *
            document.querySelector('[name="quantity"]').value
          ).toLocaleString()}`;
          if (modal.errorFlg) {
            modal.error.style.display = 'block';
          } else {
            modal.error.style.display = 'none';
          }
          if (DL_hasClass(this, 'is-disabled')) {
            event.preventDefault();
            return false;
          } else {
            const target = modal.WLPersonalizeFields();
            if (
              target.engraving_handle === 'type-pi-text' ||
              target.engraving_handle === 'type-i-text'
            ) {
              if (target.text1 === '' || target.text2 === '') {
                event.preventDefault();
                modal.errorFlg = true;
                modal.error.querySelector('span').textContent =
                  'テキストが入力されていません';
                if (modal.errorFlg) {
                  modal.error.style.display = 'block';
                } else {
                  modal.error.style.display = 'none';
                }
                return false;
              }
            }
            DL_alpha0(modal.wrap, 200, function () {
              modal.wrap.scrollTop = 0;
              modal.right.scrollTop = 0;
              DL_addClass(modal, 'is-confirm');
              DL_alpha1(modal.wrap, 200);
            });
          }
        },
        false,
      );
    }

    ////////////////////////確認から戻るボタン
    modal.back = document.querySelectorAll('.dl-personalize__back__button');
    for (var i = 0; i < modal.confirmButton.length; i++) {
      modal.back[i].addEventListener(
        'click',
        function (e) {
          DL_alpha0(modal.wrap, 200, function () {
            modal.wrap.scrollTop = 0;
            DL_removeClass(modal, 'is-confirm');
            DL_alpha1(modal.wrap, 200);
          });
        },
        false,
      );
    }

    ////////////////////////
    modal.valueColor = ''; //
    modal.valueIcon = '';
    modal.valueIconType = '';
    modal.valueTextArray = new Array(3);
    modal.valueIconType = null;
    modal.maxLength = 0;
    modal.fieldLength = 0;
    modal.error = document.querySelector('.dl-personalize__error');
    modal.errorFlg = false;

    ////////////////////////カラー選択→ KINTOのget処理に統合(/item/detail.php)
    modal.colorRadio = document.querySelectorAll('.custom-color');
    for (var i = 0; i < modal.colorRadio.length; i++) {
      modal.colorRadio[i].addEventListener('change', function () {
        modal.changeColor();
      });
    }
    // modal.colorRadio[0].checked = true;
    // modal.changeColor();

    ////////////////////////刻印選択
    modal.iconParent = document.querySelectorAll(
      '.dl-personalize__custom__icon__list__head li',
    );
    modal.iconBox = document.querySelectorAll(
      '.dl-personalize__custom__icon__list__box',
    );

    modal.iconList = document.querySelector(
      '.dl-personalize__custom__icon__list',
    );
    modal.iconListClose = document.querySelectorAll(
      '.dl-personalize__custom__icon__list__close',
    );

    for (var i = 0; i < modal.iconParent.length; i++) {
      modal.iconParent[i].setAttribute('data-idx', i);

      modal.iconBox[i]?.setAttribute('data-idx', i);
      modal.iconParent[i].addEventListener(
        'click',
        function () {
          if (DL_hasClass(this, 'is-open')) {
            DL_removeClass(this, 'is-open');
            DL_removeClass(modal.iconList, 'is-open');
            DL_removeClass(modal.iconParent, 'is-open');
            DL_removeClass(modal.iconBox, 'is-open');
            modal.iconOpenFlg = false;
          } else {
            DL_removeClass(modal.iconParent, 'is-open');
            DL_removeClass(modal.iconBox, 'is-open');
            DL_addClass(this, 'is-open');
            DL_addClass(modal.iconList, 'is-open');
            DL_addClass(
              modal.iconBox[this.getAttribute('data-idx')],
              'is-open',
            );
            modal.iconOpenFlg = true;
          }
          DL_removeClass(modal.innerModalPopupButton, 'is-active');
        },
        false,
      );
    }
    for (var i = 0; i < modal.iconListClose.length; i++) {
      modal.iconListClose[i].addEventListener(
        'click',
        function () {
          if (modal.iconOpenFlg) {
            DL_removeClass(this, 'is-open');
            DL_removeClass(modal.iconList, 'is-open');
            DL_removeClass(modal.iconParent, 'is-open');
            DL_removeClass(modal.iconBox, 'is-open');
            modal.iconOpenFlg = false;
          }
        },
        false,
      );
    }

    modal.wrap.addEventListener('click', function (e) {
      if (modal.iconOpenFlg) {
        if (
          !e.target.closest(
            '.dl-personalize__custom__icon__list__head ul li, .dl-personalize__custom__icon__list__box ul li',
          )
        ) {
          DL_removeClass(this, 'is-open');
          DL_removeClass(modal.iconList, 'is-open');
          DL_removeClass(modal.iconParent, 'is-open');
          DL_removeClass(modal.iconBox, 'is-open');
          modal.iconOpenFlg = false;
        }
      }
    });

    modal.iconRadio = document.querySelectorAll('.custom-icon');
    for (var i = 0; i < modal.iconRadio.length; i++) {
      modal.iconRadio[i].addEventListener('change', function () {
        modal.changeIcon();
      });
    }

    ////////////////////////テキスト入力
    modal.textInput = document.querySelectorAll('.custom-text');
    for (var i = 0; i < modal.textInput.length; i++) {
      modal.textInput[i].setAttribute('data-idx', i);
      modal.textInput[i].addEventListener('input', function () {
        modal.changeText(this);
      });
    }

    ////////////////////////画像
    modal.image = document.querySelector('.dl-personalize__image');
    modal.imageWrap = document.querySelector('.dl-personalize__image__wrap');
    modal.imageBase = document.querySelector('.dl-personalize__image__base');
    modal.imageButton = document.querySelector(
      '.dl-personalize__image__button',
    );

    modal.imageButton.addEventListener('click', function (event) {
      if (DL_hasClass(modal.imageButton, 'is-active')) {
        DL_removeClass(modal.image, 'is-active');
        DL_removeClass(modal.imageWrap, 'is-active');
        DL_removeClass(modal.imageBase, 'is-active');
        DL_removeClass(modal.imageButton, 'is-active');
      } else {
        DL_addClass(modal.image, 'is-active');
        DL_addClass(modal.imageWrap, 'is-active');
        DL_addClass(modal.imageBase, 'is-active');
        DL_addClass(modal.imageButton, 'is-active');
      }
    });

    ////////////////////////内部モーダル
    modal.innerModal = document.querySelector('.dl-personalize__modal');
    modal.innerModalContents = document.querySelectorAll(
      '.dl-personalize__modal__content',
    );
    modal.innerModalContentsTarget = null;
    modal.innerModalOpenButton = document.querySelectorAll(
      '.dl-personalize__modal__open',
    );
    for (var i = 0; i < modal.innerModalOpenButton.length; i++) {
      modal.innerModalOpenButton[i].addEventListener(
        'click',
        function () {
          let target = this.getAttribute('data-modal');
          modal.innerModalOpen(target);
          if (target == 'idea') {
            DL_removeClass(modal.innerModalPopupButton, 'is-active');
            clearTimeout(modal.innerModalPopupTimer);
            modal.innerModalPopupTimer = null;
            modal.innerModalPopupFlg = false;
          }
        },
        false,
      );
    }
    // modal.innerModalOpen("idea");
    modal.innerModalCloseButton = document.querySelectorAll(
      '.dl-personalize__modal__close',
    );
    for (var i = 0; i < modal.innerModalCloseButton.length; i++) {
      modal.innerModalCloseButton[i].addEventListener(
        'click',
        function () {
          modal.innerModalClose();
        },
        false,
      );
    }
    modal.innerModal.addEventListener(
      'click',
      function (e) {
        if (!e.target.closest('.dl-personalize__modal__content__wrap')) {
          modal.innerModalClose();
        }
      },
      false,
    );

    modal.innerModalPopupButton = document.querySelector(
      '.dl-personalize__modal__popup',
    );
    modal.innerModalPopupCloseButton = document.querySelector(
      '.dl-personalize__modal__popup__close',
    );

    modal.innerModalPopupCloseButton.addEventListener(
      'click',
      function () {
        DL_removeClass(modal.innerModalPopupButton, 'is-active');
      },
      false,
    );

    modal.innerModalPopupCloseButton.addEventListener(
      'click',
      function () {
        DL_removeClass(modal.innerModalPopupButton, 'is-active');
      },
      false,
    );
    modal.params = new URLSearchParams(window.location.search);
    if (modal.params.has('engraving')) {
      modal.open(); ///DEV消す
    }
    modal.init();
    window.addEventListener('resize', this.onResize.bind(modal));
  }

  _WLClickEvt() {
    const modal = this;

    ////////////////////////OPENボタン
    modal.openFlg = false;

    modal.openButton = document.querySelectorAll('.dl-personalize__open');
    modal.wrap = document.querySelector('.dl-personalize__wrap');
    modal.right = document.querySelector('.dl-personalize__right');
    for (var i = 0; i < modal.openButton.length; i++) {
      modal.openButton[i].addEventListener(
        'click',
        function () {
          if (document.body.scrollTop > 0) {
            document.body.scrollTop -= 10;
          }
          modal.wrap.scrollTop = 0;
          modal.right.scrollTop = 0;
          modal.open();
        },
        false,
      );
    }
  }

  init() {
    //OPEN処理
    const modal = this;
    // modal.scale = document.querySelector(".dl-personalize__left").offsetWidth / 800;
    if (
      document.querySelector('.dl-personalize__left').offsetWidth >
      document.querySelector('.dl-personalize__left').offsetHeight * 0.9
    ) {
      modal.scale =
        (document.querySelector('.dl-personalize__left').offsetHeight * 0.9) /
        700;
    } else {
      modal.scale =
        document.querySelector('.dl-personalize__left').offsetWidth / 700;
    }

    if (modal.scale > 1) {
      modal.scale = 1;
    }
    // console.log(document.querySelector(".dl-personalize__left").offsetWidth)
    modal.imageWrap.style.transform =
      'translate(-50%,-50%) scale(' + modal.scale + ')';
    // modal.imageWrap.style.transform = "scale(" + modal.scale + ")";
    // console.log("スケール:" + modal.scale);
    this.params = new URLSearchParams(window.location.search);
    const target = this.params.get('engraving');

    let checkedIcon = document.querySelector(
      `[name="custom-icon"][value="${target}"]`,
    );
    modal.changeColor();
    KINTO.setEngravingSetting._setParam();
    KINTO.setEngravingSetting._changeParam();
    KINTO.setEngravingSetting._setEngravingData();
    KINTO.setEngravingSetting._engravingItemCartAddEvt();

    modal.changeIcon(checkedIcon);
    // for (var i = 0; i < modal.textInput.length; i++) {
    //   modal.changeText(modal.textInput[i]);
    // }
  }

  open() {
    //OPEN処理
    const modal = this;

    if (!modal.openFlg) {
      console.log('OPEN');
      modal.openFlg = true;
      document.body.style.overflow = 'hidden';
      DL_addClass(modal, 'is-open');

      DL_fadeIn(modal, 200, function () {
        modal.innerModalPopupFlg = true;
        modal.popupTimerStart();
        modal.init();
      });
    }
  }

  close() {
    //CLOSE処理
    const modal = this;
    if (modal.openFlg) {
      console.log('CLOSE');
      DL_fadeOut(modal, 200, function () {
        modal.openFlg = false;
        document.body.style.overflow = 'inherit';
        DL_removeClass(modal, 'is-open');
        DL_removeClass(modal, 'is-confirm');
        DL_removeClass(modal.innerModalPopupButton, 'is-active');
        modal.innerModalClose();
        clearTimeout(modal.innerModalPopupTimer);
        modal.innerModalPopupTimer = null;
        modal.innerModalPopupFlg = false;
        modal.error.style.display = 'none';
        const params = new URLSearchParams(window.location.search);
        params.delete('engraving');
        params.delete('text1');
        params.delete('text2');
        params.delete('text3');
        const fields = document.querySelectorAll('.custom-text');
        const engravings = document.querySelectorAll('.wl-engraving-text');
        for (let field of fields) {
          field.value = '';
        }
        for (let engraving of engravings) {
          engraving.innerHTML = '';
        }
        window.history.replaceState('', '', `?${params.toString()}`);
      });
    }
  }

  onResize() {
    // リサイズ処理
    const modal = this;
    modal.init();
  }

  // changeParamSetData(elm, val) {
  //   console.log("setdata");
  //   // KINTO['setEngravingSetting']から呼び出せるか？

  //   //
  // }

  changeColor() {
    const modal = this;
    if (!document.querySelector('[name="color"]:checked')) {
      document.querySelectorAll('[name="color"]')[0].checked = true;
    }
    modal.valueColor = document.querySelector('[name="color"]:checked').value;
    modal.setData();

    const guideImage = document.querySelector(
      '.dl-personalize__image.is_guide',
    );
    if (guideImage) {
      const checkedColor = document.querySelector('[name="custom-color"]:checked');
      const guideImageUrl = checkedColor.getAttribute(
        'data-engraving-strap-guide-image',
      );
      if (guideImageUrl) {
        guideImage.style.backgroundImage = `url(${guideImageUrl})`;
        const strapGuide = document.querySelector('[data-strap-guide]');
        if (strapGuide) {
          strapGuide.style.display = 'block';
        }
      } else {
        guideImage.style.backgroundImage = '';
        const strapGuide = document.querySelector('[data-strap-guide]');
        if (strapGuide) {
          strapGuide.style.display = 'none';
        }
      }
    }    
  }

  changeIcon(checkedIcon = false) {
    //刻印選択処理
    const modal = this;
    if (!checkedIcon) {
      checkedIcon = document.querySelector('[name="custom-icon"]:checked');
    }
    this.engravingData = KINTO['setEngravingSetting']._getEngravingData();

    if (checkedIcon) {
      let idx = checkedIcon
        .closest('.dl-personalize__custom__icon__list__box')
        .getAttribute('data-idx');
      DL_removeClass(modal.iconParent, 'is-active');
      DL_addClass(modal.iconParent[idx], 'is-active');
      modal.valueIcon = checkedIcon.value;
      modal.valueIconType = checkedIcon.getAttribute('data-type');

      modal.valueIconImage = checkedIcon.getAttribute(
        'wl-engraving-background-image',
      );
      modal.valueIconName = checkedIcon.getAttribute('data-name');

      modal.maxLength = checkedIcon.getAttribute('data-length');
      modal.fieldLength = checkedIcon.getAttribute('data-field');
      // console.log(checkedIcon.value + "が選択されました");

      // popup出さない
      DL_removeClass(modal.innerModalPopupButton, 'is-active');
      clearTimeout(modal.innerModalPopupTimer);
      modal.innerModalPopupTimer = null;
      modal.innerModalPopupFlg = false;
    }

    for (var i = 0; i < modal.textInput.length; i++) {
      if (i < modal.fieldLength) {
        modal.textInput[i].disabled = false;
        // modal.textInput[i].value = modal.valueTextArray[i];
        // modal.textInput[i].placeholder = "入力してください";
        modal.checkTextCount(modal.textInput[i], true);
        modal.valueTextArray[i] = modal.textInput[i].value;
        if (i >= 1 && modal.textInput[i - 1].value.length == 0) {
          modal.textInput[i].disabled = true;
          modal.valueTextArray[i] = '';
          modal.textInput[i].value = null;
          // modal.textInput[i].placeholder = "入力できません";
          modal.checkTextCount(modal.textInput[i], false);
        }
      } else {
        modal.textInput[i].disabled = true;
        modal.valueTextArray[i] = '';
        modal.textInput[i].value = null;
        // modal.textInput[i].placeholder = "入力できません";
        modal.checkTextCount(modal.textInput[i], false);
      }
    }
    modal.setData();
  }

  changeText(_input) {
    //テキスト入力処理
    const modal = this;
    // **********************
    //
    //
    // エラー処理をするとしたらここか
    //
    //
    // **********************
    
    modal.checkTextCount(_input, true);
    modal.valueTextArray[_input.getAttribute('data-idx')] = _input.value;
    modal.setData();
  }

  checkTextCount(_input, display, hasError = false) {
    const modal = this;
    let inputCount = _input.value.length;
    let textCountWrap = _input.parentElement.querySelector(
      '.dl-personalize__custom__text__count',
    );
    let textCount = _input.parentElement.querySelector(
      '.dl-personalize__custom__text__count .num',
    );
    let errorWrap = _input.parentElement.querySelector(
      '.dl-personalize__custom__text__error',
    );
    textCount.innerText = inputCount + '/' + modal.maxLength;
    const reg = new RegExp(_input.dataset.pattern, 'u');
    if (reg && reg.test(_input.value) === false && inputCount > 0) {
      DL_addClass(textCountWrap, 'is-error');
      errorWrap.innerText = '入力できない文字が含まれています。';
      errorWrap.style.display = 'block';
      modal.errorFlg = true;
    } else if (
      _input.dataset.type?.match(
        /Type C|Type D|Type E|Type M|Type PC|Type PD|Type PE|Type PM/,
      ) &&
      /^(?=.*[0-9])(?=.*[a-zA-Z]).+$/.test(_input.value)
    ) {
      DL_addClass(textCountWrap, 'is-error');
      errorWrap.innerText = '英字と数字の組み合わせはできません。';
      errorWrap.style.display = 'block';
    } else if (inputCount > modal.maxLength || hasError == true) {
      // 文字数判定
      DL_addClass(textCountWrap, 'is-error');
      errorWrap.innerText = '文字数がオーバーしています。';
      errorWrap.style.display = 'block';
    } else {
      DL_removeClass(textCountWrap, 'is-error');
      errorWrap.style.display = 'none';
    }

    if (display) {
      DL_addClass(textCountWrap, 'is-active');
    } else {
      DL_removeClass(textCountWrap, 'is-active');
    }
  }

  checkError(hasError = false) {
    const modal = this;
    let errorText = '';
    modal.errorFlg = false;

    if (!modal.valueIcon) {
      errorText += '刻印が選択されていません。';
      modal.errorFlg = true;
    }

    if (modal.fieldLength == 0 && modal.dataset.illustOnly == 'false') {
      errorText += 'テキストが入力されていません';
      modal.errorFlg = true;
    } else {
      const target = modal.valueIcon || null;
      
      if (target && (/type-n|type-pn/).test(target)) {
        const isEveryEmpty = modal.valueTextArray.every((text) => text === '');
        if (isEveryEmpty && modal.dataset.illustOnly == 'false') {
          errorText += 'テキストが入力されていません';
          modal.errorFlg = true;
        }
      } else {
        if (!modal.valueTextArray[0] && modal.dataset.illustOnly == 'false') {
          errorText += 'テキストが入力されていません';
          modal.errorFlg = true;
        }
      }
    }

    let textCountError = document.querySelectorAll(
      '.dl-personalize__custom__text__count.is-error',
    );
    if (textCountError.length > 0) {
      errorText += '入力内容にエラーがあります。';
      modal.errorFlg = true;
    }

    // this.params の代わりに modal.valueIcon と modal.valueTextArray を使用
    const target = modal.valueIcon || null;
    const text1 = modal.valueTextArray[0] || '';
    const text2 = modal.valueTextArray[1] || '';
    if (/^\s*$/.test(text1) || /^\s*$/.test(text2)) {
    }
    if (
      /type-j|type-k|type-f-no-icon|type-g-no-icon|type-pj|type-pk|type-pf-no-icon|type-pg-no-icon/.test(
        target,
      ) && textCountError.length === 0
    ) {
      modal.errorFlg = false;
    }
    // console.log(target)
    if (
      /type-f-no-icon|type-g-no-icon|type-pf-no-icon|type-pg-no-icon|type-i-text|type-pi-text/.test(
        target,
      )
    ) {
      if (text1 == '' && text2 == '') {
        errorText = 'テキストが入力されていません';
        modal.errorFlg = true;
      }
    }

    if (/type-i-text|type-pi-text/.test(target)) {
      if (text1 == '' || text1 == null) {
        errorText = 'テキストが入力されていません';
        modal.errorFlg = true;
      } else if (text2 == '' || text2 == null) {
        errorText = 'テキストが入力されていません';
        modal.errorFlg = true;
      }
    }

    if (
      (text1 && text1.length > 0 && text1.trim() === '') ||
      (text2 && text2.length > 0 && text2.trim() === '')
    ) {
      errorText = 'スペースのみはご利用できません';
      modal.errorFlg = true;
      modal.error.querySelector('span').textContent = errorText;
      DL_addClass(modal.confirmButton, 'is-disabled');
    }

    if (modal.errorFlg && modal.dataset.illustOnly == 'false') {
      modal.error.querySelector('span').textContent = errorText;
      DL_addClass(modal.confirmButton, 'is-disabled');
    } else {
      modal.error.style.display = 'none';
      // DL_removeClass(modal.confirmButton, "is-disabled");
    }
  }

  setData(param = false) {
    //取りまとめる処理
    const modal = this;

    // this.params を最初に初期化
    if (param) {
      this.params = new URLSearchParams(param);
    } else {
      this.params = new URLSearchParams(window.location.search);
    }

    if (document.querySelectorAll('.dl-personalize__result__color')) {
      for (let result of document.querySelectorAll(
        '.dl-personalize__result__color',
      )) {
        if (this.params.get('color')) {
          result.innerText = this.params.get('color');
        } else {
          result.innerText = modal.valueColor;
        }
      }
    }

    if (document.querySelectorAll('.dl-personalize__result__type')) {
      for (
        var i = 0;
        i < document.querySelectorAll('.dl-personalize__result__type').length;
        i++
      ) {
        let result = document.querySelectorAll('.dl-personalize__result__type')[
          i
        ];
        if (modal.valueIconType) {
          result.textContent = 'Type : ' + modal.valueIconType;
        } else {
          result.textContent = '未選択';
        }
      }
    }

    if (document.querySelectorAll('.dl-personalize__result__icon')) {
      for (
        var i = 0;
        i < document.querySelectorAll('.dl-personalize__result__icon').length;
        i++
      ) {
        let result = document.querySelectorAll('.dl-personalize__result__icon')[
          i
        ];
        if (modal.valueIcon) {
          // result.textContent = modal.valueIcon;
          result.textContent = modal.valueIconName;
          if (result.closest('.dl-personalize__custom__box__text')) {
            result.closest('.dl-personalize__custom__box__text').style.display =
              'block';
          }
        } else {
          result.textContent = '未選択';
          if (result.closest('.dl-personalize__custom__box__text')) {
            result.closest('.dl-personalize__custom__box__text').style.display =
              'none';
          }
        }
      }
    }

    if (document.querySelectorAll('.dl-personalize__result__text')) {
      var text = '';
      this.engravingData = KINTO['setEngravingSetting']._getEngravingData();

      for (let i in modal.valueTextArray) {
        if (parseInt(this.engravingData?.engraving_field_count) > i) {
          text += `${parseInt(i) + 1}行目:<span data-wovn-ignore>${modal.valueTextArray[i]}</span><br>`;
        }
      }
      for (
        var i = 0;
        i < document.querySelectorAll('.dl-personalize__result__text').length;
        i++
      ) {
        let result = document.querySelectorAll('.dl-personalize__result__text')[
          i
        ];
        if (text) {
          result.innerHTML = text;
        } else {
          result.textContent = '未入力';
        }
      }
    }

    if (document.querySelector('.maxlength') && modal.maxLength) {

      if (this.params.get('engraving')) {
        const set = this.querySelector(
          `.custom-icon[value="${this.params.get('engraving')}"]`,
        );
        if (parseInt(set.dataset.field) > 1) {
          document.querySelector('.maxlength').textContent =
            '（最大文字数 各' + modal.maxLength + '文字）';
        } else {
          if (set.dataset.type.match(/Type D|Type E|Type PD|Type PE/)) {
            document.querySelector('.maxlength').textContent =
              '（最大文字数 アルファベット1文字、数字2文字）';
          } else {
            document.querySelector('.maxlength').textContent =
              '（最大文字数 ' + modal.maxLength + '文字）';
          }
        }
      }
    } else {
      document.querySelector('.maxlength').textContent = '';
    }

    clearTimeout(modal.innerModalPopupTimer);
    modal.innerModalPopupTimer = null;
    if (modal.innerModalPopupFlg) {
      modal.popupTimerStart();
    }
    modal.checkError();
  }

  innerModalOpen(_target) {
    const modal = this;

    for (var i = 0; i < modal.innerModalContents.length; i++) {
      if (modal.innerModalContents[i].getAttribute('data-modal') == _target) {
        modal.innerModalContentsTarget = modal.innerModalContents[i];
      }
    }
    if (_target == 'idea') {
      //スライダーに合わせて読み込みタイミングを調整
      DL_addClass(modal.innerModal, 'is-open');
      DL_fadeIn(modal.innerModal, 200, function () {
        modal.innerModalContentsTarget.style.display = 'block';
        modal.innerModalContentsTarget.style.opacity = 0;
        modal.showIdeaSlide();
        DL_fadeIn(modal.innerModalContentsTarget, 200);
      });
    } else {
      DL_addClass(modal.innerModal, 'is-open');
      DL_fadeIn(modal.innerModal, 200, function () {
        DL_fadeIn(modal.innerModalContentsTarget, 200);
      });
    }
  }

  innerModalClose() {
    const modal = this;
    DL_fadeOut(modal.innerModal, 200, function () {
      for (var i = 0; i < modal.innerModalContents.length; i++) {
        modal.innerModalContents[i].style.display = 'none';
      }
      if (modal.splide) {
        modal.hideIdeaSlide();
      }
    });
  }

  popupTimerStart() {
    const modal = this;
    modal.innerModalPopupTimer = setTimeout(function () {
      clearTimeout(modal.innerModalPopupTimer);
      modal.innerModalPopupTimer = null;
      modal.innerModalPopupFlg = false;
      DL_addClass(modal.innerModalPopupButton, 'is-active');
      modal.popupOffTimerStart();
    }, 5000);
  }

  popupOffTimerStart() {
    const modal = this;
    modal.popupOffTimer = setTimeout(function () {
      clearTimeout(modal.popupOffTimer);
      modal.popupOffTimer = null;
      DL_removeClass(modal.innerModalPopupButton, 'is-active');
    }, 5000);
  }

  showIdeaSlide() {
    const modal = this;
    modal.idea = document.querySelector('.dl-personalize .splide');
    var options = {
      type: 'loop',
      focus: 'center',
      perPage: 3,
      focus: 0,
      gap: '2rem',
      arrows: true,
      autoplay: true,
      interval: 3000,
      speed: 1000,
      pagination: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      breakpoints: {
        1000: {
          perPage: 2,
          padding: '2rem',
        },
        680: {
          perPage: 1,
          padding: '2rem',
          // arrows: false,
        },
      },
    };
    modal.splide = new Splide(modal.idea, options);
    modal.splide.on('mounted', function () {
      modal.ideaFlg = true;
      addClass(modal.idea, 'is-active');
    });

    modal.splide.on('overflow', function (isOverflow) {
      if (isOverflow) {
        // 十分なスライドがあるときの処理
      } else {
        modal.splide.go(0);
        modal.splide.options = {
          arrows: isOverflow,
          pagination: isOverflow,
          drag: isOverflow,
          clones: isOverflow ? undefined : 0, // クローンの破棄・再生成
        };
        // addClass(SplideFunc.object[i],"col-"+SplideFunc.object[i].querySelectorAll(".splide__slide").length)
        // スライドが不足しているときの処理
      }
    });
    modal.splide.mount();
  }

  hideIdeaSlide() {
    const modal = this;
    console.log('hideIdeaSlide');
    modal.splide.destroy();
    modal.splide.refresh();
    modal.splide = null;
    removeClass(modal.idea, 'is-active');
  }
  WLPersonalizeFields() {
    const engravingData = KINTO.setEngravingSetting._getEngravingData();
    const engravingFields = this.WLPersonalizeFieldData(engravingData);

    // 初期化
    const fields = document.querySelectorAll('.wl-input');
    for (let field of fields) {
      field.remove();
    }

    const textList =
      engravingData.text1 + engravingData.text2 + engravingData.text3;
    let v = '';

    if (
      /Type A|Type B|Type C|Type D|Type E|Type M|Type PA|Type PB|Type PC|Type PD|Type PE|Type PM/u.test(
        engravingData.engraving_id,
      ) &&
      /[a-zA-Z]|[\u3040-\u309F]+$|[\u30A0-\u30FF]+$/u.test(textList)
    ) {
      v = engravingData.engraving_id + ' ' + textList.length + '文字';
    } else if (
      /Type A|Type B|Type C|Type D|Type E|Type M|Type PA|Type PB|Type PC|Type PD|Type PE|Type PM/u.test(
        engravingData.engraving_id,
      ) &&
      /[0-9]+$/u.test(textList)
    ) {
      v = engravingData.engraving_id + ' 数字';
    } else {
      v = engravingData.engraving_id + ' 文字';
    }

    this.cartForm = document.querySelector('#_cart_form');
    if (!this.cartForm) return;

    let html = '';
    html += `<input type="hidden" class="wl-input" name="properties[Font / Design]" data-wl-engraving-field="Font / Design" value="${v}">`;
    for (let field in engravingFields[engravingData.engraving_id]) {
      html += `<input type="hidden" class="wl-input" name="properties[${field}]" data-wl-engraving-field="${field}" value="${
        engravingFields[engravingData.engraving_id][field]
      }">`;
    }
    html += `<input type="hidden" class="wl-input" name="properties[__optionVariantId]" data-wl-engraving-field="__optionVariantId" value="${engravingData.engraving_product_cost?.id}">`;
    html += `<input type="hidden" class="wl-input" name="properties[__optionPrice]" data-wl-engraving-field="__optionPrice" value="${
      engravingData.engraving_product_cost?.price
        ? '¥' +
          (engravingData.engraving_product_cost?.price / 100).toLocaleString()
        : 0
    }">`;
    this.cartForm.innerHTML += html;
    return engravingData;
  }
  WLPersonalizeFieldData(engravingData) {
    return {
      'Type A': {
        Text: engravingData.text1,
      },
      'Type B': {
        Text: engravingData.text1,
      },
      'Type C': {
        Text: engravingData.text1,
      },
      'Type D': {
        Text: engravingData.text1,
      },
      'Type E': {
        Text: engravingData.text1,
      },
      'Type F': {
        Illust: engravingData.engraving_title,
        'Text Line 1': engravingData.text1,
        'Text Line 2': engravingData.text2,
      },
      'Type G': {
        IllustB: engravingData.engraving_title,
        'Text LineG 1': engravingData.text1,
        'Text LineG 2': engravingData.text2,
      },
      'Type H': {
        'Vertical Text 1': engravingData.text1,
        'Vertical Text 2': engravingData.text2 ? engravingData.text2 : null,
      },
      'Type I': {
        Emblem: engravingData.engraving_title,
        'Text Line TypeI': engravingData.text1,
        'Text Line TypeI2': engravingData.text2 ? engravingData.text2 : null,
      },
      'Type J': {
        Frame: engravingData.engraving_title,
        'Frame Text 1': engravingData.text1,
        'Frame Text 2': engravingData.text2,
        'Frame Text 3': engravingData.text3,
      },
      'Type K': {
        Frame: engravingData.engraving_title,
        'Frame Text 1': engravingData.text1,
        'Frame Text 2': engravingData.text2,
        'Frame Text 3': engravingData.text3,
      },
      'Type L': {
        'Vertical Text 1': engravingData.text1,
        'Vertical Text 2': engravingData.text2 ? engravingData.text2 : null,
      },
      'Type M': {
        Text: engravingData.text1,
      },
      'Type PA': {
        Text: engravingData.text1,
      },
      'Type PB': {
        Text: engravingData.text1,
      },
      'Type PC': {
        Text: engravingData.text1,
      },
      'Type PD': {
        Text: engravingData.text1,
      },
      'Type PE': {
        Text: engravingData.text1,
      },
      'Type PF': {
        Illust: engravingData.engraving_title,
        'Text Line 1': engravingData.text1,
        'Text Line 2': engravingData.text2,
      },
      'Type PG': {
        IllustB: engravingData.engraving_title,
        'Text LineG 1': engravingData.text1,
        'Text LineG 2': engravingData.text2,
      },
      'Type PH': {
        'Vertical Text 1': engravingData.text1,
        'Vertical Text 2': engravingData.text2 ? engravingData.text2 : null,
      },
      'Type PI': {
        Emblem: engravingData.engraving_title,
        'Text Line TypeI': engravingData.text1,
        'Text Line TypeI2': engravingData.text2 ? engravingData.text2 : null,
      },
      'Type PJ': {
        Frame: engravingData.engraving_title,
        'Frame Text 1': engravingData.text1,
        'Frame Text 2': engravingData.text2,
        'Frame Text 3': engravingData.text3,
      },
      'Type PK': {
        Frame: engravingData.engraving_title,
        'Frame Text 1': engravingData.text1,
        'Frame Text 2': engravingData.text2,
        'Frame Text 3': engravingData.text3,
      },
      'Type PL': {
        'Vertical Text 1': engravingData.text1,
        'Vertical Text 2': engravingData.text2 ? engravingData.text2 : null,
      },
      'Type PM': {
        Text: engravingData.text1,
      },
      'Type P': {
        IllustP: engravingData.engraving_title,
        'Text LineP': engravingData.text1,
      },
      'Type N': {
        'Frame Text 1': engravingData.text1,
        'Frame Text 2': engravingData.text2,
        'Frame Text 3': engravingData.text3,
      },
      'Type O': {
        Text: engravingData.text1,
      },
      'Type PN': {
        'Frame Text 1': engravingData.text1,
        'Frame Text 2': engravingData.text2,
        'Frame Text 3': engravingData.text3,
      },
      'Type PP': {
        IllustP: engravingData.engraving_title,
        'Text LineP': engravingData.text1,
      },
      'Type PO': {
        Text: engravingData.text1,
      },
    };
  }

  connectedCallback() {} //add
  disconnectedCallback() {} //remove
  attributeChangedCallback() {} //属性変更
}
customElements.define('dl-personalize', DL_Personalize);
